import React, { useState } from "react";
import { ExternalLink, Github, Figma, Code, Database, Palette, Calendar, Users, Heart, Sparkles, Star } from "lucide-react";

const Projects = () => {
  const projects = [
    {
      id: 1,
      title: "Website Profil Perusahaan",
      description: "Website profil perusahaan dengan desain responsif dan komponen antarmuka modern.",
      technologies: ["HTML", "CSS", "JavaScript"],
      category: "Pengembangan Web",
      status: "Selesai",
      icon: Code,
      gradient: "from-blue-500 to-cyan-500",
      image: "/api/placeholder/400/250",
      links: {
        demo: "#",
        github: "#"
      }
    },
    {
      id: 2,
      title: "Aplikasi Berita Sederhana",
      description: "Aplikasi berita sederhana dengan sistem manajemen konten dan antarmuka yang ramah pengguna.",
      technologies: ["Laravel", "MySQL", "Bootstrap"],
      category: "Pengembangan Web",
      status: "Selesai",
      icon: Database,
      gradient: "from-red-500 to-pink-500",
      image: "/api/placeholder/400/250",
      links: {
        demo: "#",
        github: "#"
      }
    },
    {
      id: 3,
      title: "Sistem Perpustakaan Sederhana",
      description: "Sistem manajemen perpustakaan sekolah dengan fitur katalog buku dan peminjaman.",
      technologies: ["Laravel", "MySQL", "React"],
      category: "Full Stack",
      status: "Selesai",
      icon: Database,
      gradient: "from-purple-500 to-indigo-500",
      image: "/api/placeholder/400/250",
      links: {
        demo: "#",
        github: "#"
      }
    },
    {
      id: 4,
      title: "UI/UX Aplikasi Transportasi",
      description: "Desain UI/UX kolaboratif untuk aplikasi transportasi dengan tampilan modern dan intuitif.",
      technologies: ["Figma", "Desain UI/UX"],
      category: "Desain UI/UX",
      status: "Selesai",
      icon: Palette,
      gradient: "from-green-500 to-emerald-500",
      image: "/api/placeholder/400/250",
      links: {
        figma: "https://www.figma.com/proto/Erici1dmy25CRo7aoPGQJQ/Kelompok-1-%7C-Projek-2-Minggu?node-id=788-591&starting-point-node-id=1179%3A1146"
      }
    },
    {
      id: 5,
      title: "Senyum Sehat Ceria",
      description: "Desain antarmuka aplikasi kesehatan yang dibuat dalam pelatihan LKS Desain Grafis.",
      technologies: ["Figma", "Prototyping"],
      category: "Desain UI/UX",
      status: "Selesai",
      icon: Heart,
      gradient: "from-pink-500 to-rose-500",
      image: "/api/placeholder/400/250",
      links: {
        figma: "https://www.figma.com/proto/n8L1Mc9vBgYkMntWFM4vju/01_Modul-4_Hifi?node-id=3-6&p=f&t=6rSavL5ls4rHqC4X-0&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=1%3A2"
      }
    },
    {
      id: 6,
      title: "Jakarta International Kite",
      description: "Desain aplikasi manajemen acara untuk festival layang-layang internasional di Jakarta.",
      technologies: ["Figma", "Desain Acara"],
      category: "Desain UI/UX",
      status: "Selesai",
      icon: Calendar,
      gradient: "from-orange-500 to-amber-500",
      image: "/api/placeholder/400/250",
      links: {
        figma: "https://www.figma.com/proto/Qc9QAh4ZedouKGry6PAMxE/Jakarta-InternationalKite?node-id=65-308&p=f&t=UUbHELrWD3QGyk1V-0&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=65%3A214&show-proto-sidebar=1"
      }
    },
    {
      id: 7,
      title: "Desain Kompetisi ICAD",
      description: "Desain pemenang penghargaan untuk kompetisi Indonesian Contemporary Art & Design.",
      technologies: ["Figma", "Kompetisi"],
      category: "Desain UI/UX",
      status: "Selesai",
      icon: Star,
      gradient: "from-violet-500 to-purple-500",
      image: "/api/placeholder/400/250",
      links: {
        figma: "https://www.figma.com/proto/ubWFRsLuiPtnDSBXHNMzqy/23_Modul-3?node-id=2-2&p=f&t=iFWwWXACgTDKXkje-0&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=2%3A2"
      }
    },
    {
      id: 8,
      title: "Aplikasi Pelacak Suasana Hati",
      description: "Aplikasi kesehatan mental dengan fitur pencatatan suasana hati dan analisis data.",
      technologies: ["Figma", "Flutter", "Prototype"],
      category: "Aplikasi Mobile",
      status: "Sedang Berjalan",
      icon: Heart,
      gradient: "from-teal-500 to-cyan-500",
      image: "/api/placeholder/400/250",
      links: {
        figma: "https://www.figma.com/design/VPtxnoObXCcNvF0onxkcYx/Mood-Tracking?node-id=13-2&p=f&t=suG9BnRFunQoz5Se-0"
      }
    },
    {
      id: 9,
      title: "Klon Instagram Media Sosial",
      description: "Aplikasi media sosial mirip Instagram yang dibangun menggunakan React Native dan Expo.",
      technologies: ["React Native", "Expo"],
      category: "Aplikasi Mobile",
      status: "Sedang Berjalan",
      icon: Users,
      gradient: "from-indigo-500 to-purple-500",
      image: "/api/placeholder/400/250",
      links: {
        github: "https://github.com/kinanprastiwi/Social-Media"
      }
    }
  ];

  const categories = ["Semua", "Pengembangan Web", "Desain UI/UX", "Aplikasi Mobile", "Full Stack"];
  const [activeCategory, setActiveCategory] = useState("Semua");

  const filteredProjects = activeCategory === "Semua" 
    ? projects 
    : projects.filter(project => project.category === activeCategory);

  return (
    <section id="projects" className="py-20 bg-[#F8F9FA] dark:bg-gray-800 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16 animate-slideInUp">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Code className="w-8 h-8 text-[#3A7CA5] dark:text-[#A9D6E5] animate-pulse" />
            <h2 className="text-4xl font-bold text-[#3D3D3D] dark:text-white hover:gradient-text transition-all duration-300">
              Projek Saya
            </h2>
            <Sparkles className="w-6 h-6 text-[#E6B566] animate-bounce-slow" />
          </div>
          <div className="w-20 h-1 bg-gradient-to-r from-[#3A7CA5] to-[#E6B566] mx-auto mb-6 hover:w-32 transition-all duration-500"></div>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            Menampilkan perjalanan saya dalam pengembangan web, desain UI/UX, dan pembuatan aplikasi mobile melalui 
            proyek sekolah, kompetisi, maupun karya pribadi.
          </p>
        </div>


        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12 animate-slideInUp animation-delay-300">
          {categories.map((category, index) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-6 py-3 rounded-full font-medium transition-all duration-300 transform hover:scale-110 hover:-translate-y-1 animate-fadeInScale ${
                activeCategory === category
                  ? 'bg-gradient-to-r from-[#3A7CA5] to-[#2E6B94] text-white shadow-2xl'
                  : 'bg-white dark:bg-gray-700 text-[#3A7CA5] dark:text-[#A9D6E5] hover:bg-[#3A7CA5] hover:text-white dark:hover:bg-[#A9D6E5] dark:hover:text-gray-900 shadow-md hover:shadow-xl'
              }`}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project, index) => {
            const IconComponent = project.icon;
            return (
              <div
                key={project.id}
                className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg hover:shadow-3xl transition-all duration-500 transform hover:scale-105 overflow-hidden group glow-on-hover animate-fadeInScale"
                style={{ animationDelay: `${index * 150}ms` }}
              >
                {/* Project Image */}
                <div className={`relative h-48 bg-gradient-to-br ${project.gradient} flex items-center justify-center overflow-hidden`}>
                  <div className="relative z-10">
                    <IconComponent className="w-16 h-16 text-white group-hover:scale-125 group-hover:rotate-12 transition-all duration-500" />
                  </div>
                  
                  {/* Floating particles */}
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <div className="absolute top-4 left-4 w-2 h-2 bg-white/30 rounded-full animate-bounce-slow"></div>
                    <div className="absolute top-8 right-8 w-3 h-3 bg-white/20 rounded-full animate-bounce-slow animation-delay-300"></div>
                    <div className="absolute bottom-6 left-8 w-2 h-2 bg-white/40 rounded-full animate-bounce-slow animation-delay-500"></div>
                  </div>
                  
                  {/* Status Badge */}
                  {project.status === "In Progress" && (
                    <div className="absolute top-4 right-4 px-3 py-1 bg-[#E6B566] text-white text-xs font-medium rounded-full shadow-lg animate-pulse flex items-center gap-1">
                      <div className="w-2 h-2 bg-white rounded-full animate-bounce"></div>
                      {project.status}
                    </div>
                  )}
                  
                  {/* Award badge for ICAD */}
                  {project.title === "ICAD Competition Design" && (
                    <div className="absolute top-4 left-4 px-3 py-1 bg-yellow-500 text-white text-xs font-medium rounded-full shadow-lg flex items-center gap-1">
                      <Star className="w-3 h-3" />
                      Penghargaan
                    </div>
                  )}
                </div>

                <div className="p-6">
                  {/* Category Badge */}
                  <div className="flex items-center justify-between mb-3">
                    <span className="inline-block px-3 py-1 bg-[#3A7CA5]/10 dark:bg-[#A9D6E5]/20 text-[#3A7CA5] dark:text-[#A9D6E5] text-xs font-medium rounded-full">
                      {project.category}
                    </span>
                    <div className="flex items-center gap-1">
                      <Sparkles className="w-4 h-4 text-[#E6B566] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    </div>
                  </div>

                  {/* Project Title */}
                  <h3 className="text-xl font-bold text-[#3D3D3D] dark:text-white mb-3 group-hover:text-[#3A7CA5] dark:group-hover:text-[#A9D6E5] transition-colors duration-300">
                    {project.title}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-600 dark:text-gray-400 mb-4 line-clamp-3 group-hover:text-gray-700 dark:group-hover:text-gray-300 transition-colors duration-300">
                    {project.description}
                  </p>

                  {/* Technologies */}
                  <div className="flex flex-wrap gap-2 mb-6">
                    {project.technologies.map((tech, techIndex) => (
                      <span
                        key={tech}
                        className="px-3 py-1 bg-[#F8F9FA] dark:bg-gray-800 text-[#3A7CA5] dark:text-[#A9D6E5] text-xs rounded-full border border-[#A9D6E5]/50 dark:border-gray-600 hover:bg-[#3A7CA5] hover:text-white dark:hover:bg-[#A9D6E5] dark:hover:text-gray-900 transition-all duration-300 cursor-pointer transform hover:scale-110 animate-fadeInScale"
                        style={{ animationDelay: `${techIndex * 50}ms` }}
                      >
                        {tech}
                      </span>
                    ))}
                  </div>

                  {/* Links */}
                  <div className="flex gap-3">
                    {project.links.demo && (
                      <a
                        href={project.links.demo}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-[#3A7CA5] to-[#2E6B94] text-white rounded-lg hover:shadow-lg transition-all duration-300 transform hover:scale-105 text-sm group/link"
                      >
                        <ExternalLink className="w-4 h-4 group-hover/link:rotate-45 transition-transform duration-200" />
                        Demo
                      </a>
                    )}
                    {project.links.github && (
                      <a
                        href={project.links.github}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 px-4 py-2 border border-[#3A7CA5] dark:border-[#A9D6E5] text-[#3A7CA5] dark:text-[#A9D6E5] rounded-lg hover:bg-[#3A7CA5] dark:hover:bg-[#A9D6E5] hover:text-white dark:hover:text-gray-900 transition-all duration-300 transform hover:scale-105 text-sm group/link"
                      >
                        <Github className="w-4 h-4 group-hover/link:rotate-12 transition-transform duration-200" />
                        Kode
                      </a>
                    )}
                    {project.links.figma && (
                      <a
                        href={project.links.figma}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 px-4 py-2 border border-[#E6B566] text-[#E6B566] rounded-lg hover:bg-[#E6B566] hover:text-white transition-all duration-300 transform hover:scale-105 text-sm group/link"
                      >
                        <Figma className="w-4 h-4 group-hover/link:rotate-12 transition-transform duration-200" />
                        Figma
                      </a>
                    )}
                  </div>
                </div>

                {/* Bottom gradient line */}
                <div className={`h-1 bg-gradient-to-r ${project.gradient} transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500`}></div>
              </div>
            );
          })}
        </div>

        {/* Enhanced Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16 pt-16 border-t border-gray-200 dark:border-gray-700">
          {[
            { number: "9+", label: "Projects", color: "text-[#3A7CA5]", icon: Code },
            { number: "5+", label: "UI/UX Designs", color: "text-[#E6B566]", icon: Palette },
            { number: "3+", label: "Web Apps", color: "text-[#3A7CA5]", icon: Database },
            { number: "2+", label: "Years Learning", color: "text-[#E6B566]", icon: Sparkles }
          ].map((stat, index) => {
            const IconComponent = stat.icon;
            return (
              <div key={index} className="text-center group animate-slideInUp" style={{ animationDelay: `${index * 150}ms` }}>
                <div className="relative inline-block mb-4">
                  <div className={`text-4xl font-bold ${stat.color} dark:brightness-125 mb-2 group-hover:scale-110 transition-transform duration-300`}>
                    {stat.number}
                  </div>
                  <IconComponent className={`w-8 h-8 ${stat.color} mx-auto group-hover:rotate-12 transition-transform duration-300`} />
                  {/* Floating ring */}
                  <div className="absolute inset-0 border border-current rounded-full opacity-0 group-hover:opacity-30 group-hover:scale-150 transition-all duration-500"></div>
                </div>
                <div className="text-gray-600 dark:text-gray-400 group-hover:text-gray-800 dark:group-hover:text-gray-200 transition-colors duration-300">
                  {stat.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Projects;